var ExchangeCheckoutScreen = (function ($) {

    ExchangeCheckoutScreen = function (options) {
        var that = this;

        options = options || {};

        // CONST
        that.order_hash = options['order_hash'] || null;
        that.order_passenger_hash = options['order_passenger_hash'] || null;
        that.modals = options['modals'] || {};
        that.locales = options['locales'] || {};
        that.order_url = options['order_url'];

        that.is_show_order_contact_data_modal = options['is_show_order_contact_data_modal'];

        that.storefront_id = null;
        that.final_order_hash = null;
        that.final_order_passenger_hash = null;
        that.order_payment_hash = null;
        that.final_order_url = null;
        that.final_order_pnr = null;

        that.attribute = {
            disabled: 'disabled'
        }
        that.class = {
            error: 'error',
            hidden: 'hidden',
            disabled: 'disabled'
        };
        that.selectors = {
            checkout_content: '.js-checkout-content',
            payment_form_wrapper: '.js-payment-form-wrapper',
            success_result_wrapper: '.js-exchange-success-result-wrapper',
            payment_fail_wrapper: '.js-exchange-payment-fail-wrapper',
            issue_process_fail_wrapper: '.js-exchange-issue-process-fail-wrapper',
            button_repeat_exchange: '.js-button-repeat-exchange',
            payment_form: '.js-payment-form',
            payment_details: '.js-payment-details',
            exchange_completed: '.js-exchange-completed',
            total_amount: '.js-total-amount',

            divided_order_card: '.js-divided-order-card',
            divided_order_link: '.js-divided-order-link',
            divided_order_pnr: '.js-divided-order-pnr',

            confirm_terms: '.js-confirm-terms',
            confirm_terms_tooltip_warning: '.js-confirm-terms-tooltip-warning',
            confirm_terms_tooltip_warning_checkbox: '.js-confirm-terms-tooltip-warning-checkbox',

            fareremark_info: '.js-fareremark-info',

            button_back_to_order: '.js-button-back-to-order',
            button_edit_order: '.js-button-edit-order'
        };

        // DYNAMIC VARS
        that.screen_is_locked = false;
        that.data = {};
        that.order_contact_data = {};
        that.total = 0;

        // HANDLERS
        that.onValid = (options['onValid'] || false);
        that.onPayment = (options['onPayment'] || false);

        // DOM
        that.$wrapper = options['$wrapper'];
    };

    ExchangeCheckoutScreen.prototype.init = function (data) {
        var that = this,
            deferred = $.Deferred();

        that.__getCheckout(data).done(function (response) {
            if (true === response) {
                that.data = data;
                that.__initEvents();

                deferred.resolve({
                    total: that.total
                });
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    ExchangeCheckoutScreen.prototype.isValid = function () {
        var that = this;

        if (!that.$confirm_terms_checkbox.prop('checked')) {
            that.__toggleConfirmTermsTooltip('show');
            return false;
        }

        return true;
    };

    ExchangeCheckoutScreen.prototype.getData = function () {
        return {};
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__initEvents = function () {
        var that = this;

        that.__initConfirmTerms();

        that.__initFareremark();
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__getCheckout = function (data) {
        var that = this,
            deferred = $.Deferred(),
            checkout_url = that.order_url + '/exchange/checkout';

        $.get(checkout_url, data).done(function (response, textStatus, jqXHR) {
            if (200 === jqXHR.status && response.length) {
                that.$wrapper.html(response);
                that.$checkout_content = that.$wrapper.find(that.selectors.checkout_content);
                that.$payment_form_wrapper = that.$wrapper.find(that.selectors.payment_form_wrapper);
                that.$success_result_wrapper = that.$wrapper.find(that.selectors.success_result_wrapper);
                that.$payment_fail_wrapper = that.$wrapper.find(that.selectors.payment_fail_wrapper);
                that.$issue_process_fail_wrapper = that.$wrapper.find(that.selectors.issue_process_fail_wrapper);
                that.$button_repeat_exchange = that.$wrapper.find(that.selectors.button_repeat_exchange);
                that.$payment_form = that.$payment_form_wrapper.find(that.selectors.payment_form);
                that.$payment_details = that.$checkout_content.find(that.selectors.payment_details);
                that.$exchange_completed = that.$checkout_content.find(that.selectors.exchange_completed);
                that.$fareremark_info = that.$checkout_content.find(that.selectors.fareremark_info);
                that.$total_amount = that.$payment_details.find(that.selectors.total_amount);
                that.total = that.$total_amount.data('total');

                that.$divided_order_card = that.$checkout_content.find(that.selectors.divided_order_card);
                that.$divided_order_link = that.$divided_order_card.find(that.selectors.divided_order_link);
                that.$divided_order_pnr = that.$divided_order_card.find(that.selectors.divided_order_pnr);

                that.$confirm_terms_checkbox = that.$wrapper.find(that.selectors.confirm_terms);
                that.$confirm_terms_tooltip = that.$wrapper.find(that.selectors.confirm_terms_tooltip_warning);
                that.$confirm_terms_tooltip_checkbox = that.$wrapper.find(that.selectors.confirm_terms_tooltip_warning_checkbox);

                that.storefront_id = that.$payment_form_wrapper.data('storefront-id');
                that.order_payment_hash = that.$payment_form_wrapper.data('order-payment-hash');
                that.payment_instance_id = that.$payment_form_wrapper.data('payment-instance-id');

                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }).fail(function (error) {
            deferred.reject(error);
        });

        return deferred.promise();
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.proceedPayment = function (data) {
        var that = this,
            deferred = $.Deferred();

        if (that.is_show_order_contact_data_modal && $.isEmptyObject(that.order_contact_data)) {
            that.__showOrderContactDataModal();
            deferred.resolve(false);
            return deferred.promise();
        }

        that.__initProceedPayment(data).done(function (response) {
            deferred.resolve(true === response);
        }).fail(function () {
            deferred.resolve(false);
        });

        return deferred.promise();
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__initProceedPayment = function (data) {
        var that = this,
            href = $.sa.build_url('order/exchange/checkout/payment'),
            deferred = $.Deferred();

        $.extend(data, {
            order_hash: that.order_hash,
            order_passenger_hash: that.order_passenger_hash,
            payment_instance_id: that.payment_instance_id,
            order_payment_hash: that.order_payment_hash,
            storefront_id: that.storefront_id,
            payment_email: that.order_contact_data.email || null,
            payment_phone: that.order_contact_data.phone || null,
            color_scheme: $.sa.is_dark_theme() ? 'dark' : 'light'
        });

        $.post(href, data, function (response) {
            if (typeof response !== 'object') {
                response = {
                    status: 'fail',
                    errors: [
                        {
                            code: 0,
                            message: $.sa.locales['something_went_wrong'],
                        }
                    ],
                };
            }

            switch (response.status) {
                case 'ok':
                    that.__handleProceedPaymentSuccess(response);
                    deferred.resolve(true);
                    break;
                case 'fail':
                    that.__handleProceedPaymentError();
                    deferred.resolve(false);
                    break;
            }
        }).fail(function (error) {
            that.__handleProceedPaymentError();
            deferred.reject(error);
        });

        return deferred.promise();
    };

    /**
     * @param response
     * @private
     */
    ExchangeCheckoutScreen.prototype.__handleProceedPaymentSuccess = function (response) {
        var that = this;

        that.final_order_pnr = response.data['pnr'];
        that.final_order_hash = response.data['order_hash'];
        that.final_order_passenger_hash = response.data['order_passenger_hash'];
        that.final_order_url = response.data['order_url'];
        that.order_payment_hash = response.data['order_payment_hash'];
        that.__initPaymentStatusChecker();
        that.__constructEventListener();

        that.$checkout_content.toggleClass(that.class.hidden);
        that.$payment_form_wrapper.toggleClass(that.class.hidden);
        that.$payment_form.html(response.data['order_payment_data']);
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__initPaymentStatusChecker = function () {
        var that = this,
            order_payment_status = null,
            href = $.sa.build_url('order/checkout/payment/status'),
            data = {
                order_hash: that.final_order_hash,
                order_passenger_hash: that.final_order_passenger_hash,
                order_payment_hash: that.order_payment_hash,
            };

        var counter = 0,
            is_locked = false,
            processing_shown = false,
            timer = setInterval(function () {
                if (is_locked) {
                    return;
                }

                if (counter >= 240) {
                    clearInterval(timer);
                    $.uiModal({
                        html: that.modals['payment_time_expired'],
                        close_on_avia_before_load: false,
                        onBgClick: function (modal, event) {
                            event.preventDefault();
                            return false;
                        },
                        onClose: function () {
                            $.sa.content_router.load(that.final_order_url);
                        }
                    });
                } else {
                    is_locked = true;

                    $.post(href, data, function (res) {
                        if (res && res.data) {
                            if (res.data.status) {
                                order_payment_status = res.data.status;
                            } else if (res.data.status === false) {
                                clearInterval(timer);
                                that.__showExchangeErrorModal();
                            }
                        }

                        if (order_payment_status === 'issue_processing' && !processing_shown) {
                            that.$success_result_wrapper.removeClass(that.class.hidden);
                            that.$payment_form_wrapper.addClass(that.class.hidden);
                            processing_shown = true;
                        } else if (order_payment_status === 'issued') {
                            clearInterval(timer);
                            that.$payment_details.addClass(that.class.hidden);
                            that.$exchange_completed.removeClass(that.class.hidden);
                            that.$checkout_content.removeClass(that.class.hidden);
                            that.$success_result_wrapper.addClass(that.class.hidden);
                            that.$payment_form_wrapper.addClass(that.class.hidden);

                            if (that.order_hash !== that.final_order_hash) {
                                that.$divided_order_card.removeClass(that.class.hidden);
                                that.$divided_order_link.attr('href', that.final_order_url);
                                that.$divided_order_pnr.text(that.final_order_pnr);
                            }

                            if (typeof that.onPayment === 'function') {
                                that.onPayment();
                            }
                        } else if (order_payment_status === 'canceled' || order_payment_status === 'void') {
                            clearInterval(timer);
                            that.__showPaymentFailInfo();
                        } else if (order_payment_status === 'issue_processing_failure') {
                            clearInterval(timer);
                            that.$success_result_wrapper.addClass(that.class.hidden);
                            that.$issue_process_fail_wrapper.removeClass(that.class.hidden);
                            that.$issue_process_fail_wrapper.on('click', that.selectors.button_back_to_order, function () {
                                $.sa.content_router.load(that.final_order_url);
                            });
                        }
                        is_locked = false;
                    });
                    counter++;
                }

                if (!that.$payment_form_wrapper.is(':visible') && !that.$success_result_wrapper.is(':visible')) {
                    clearInterval(timer);
                    if (window.removeEventListener) {
                        window.removeEventListener('message', that.__dispatchEventMessage);
                    }
                }
            }, 2500);
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__handleProceedPaymentError = function () {
        var that = this;

        that.__showExchangeErrorModal();
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__constructEventListener = function () {
        var that = this;

        if (window.addEventListener) {
            window.addEventListener('message', function (e) {
                that.__dispatchEventMessage(e);
            }, false);
        } else {
            console.log('postMessages not supported: https://developer.mozilla.org/ru/docs/Web/API/Window/postMessage');
        }
    };

    /**
     * @param event
     * @returns {boolean}
     * @private
     */
    ExchangeCheckoutScreen.prototype.__dispatchEventMessage = function (event) {
        var that = this,
            data = event.data;

        if (!data.length) {
            return false;
        }
        if (typeof event.data === 'string') {
            data = JSON.parse(event.data);
        }

        if (data.message_source && data.message_source === 'avia') {
            $.sa.log('Avia app event', data);
        } else {
            return false;
        }

        switch (data.type) {
            case 'retry_checkout':
                if (window.removeEventListener) {
                    window.removeEventListener('message', that.__dispatchEventMessage);
                }
                that.__showPaymentFailInfo();
                break;
        }
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__showPaymentFailInfo = function () {
        var that = this;

        that.$payment_form_wrapper.addClass(that.class.hidden);
        that.$payment_fail_wrapper.removeClass(that.class.hidden);
        that.$payment_fail_wrapper.on('click', that.selectors.button_back_to_order, function (e) {
            e.preventDefault();
            $.sa.content_router.load(that.final_order_url);
        });
        that.$payment_fail_wrapper.on('click', that.selectors.button_edit_order, function (e) {
            e.preventDefault();
            $.sa.content_router.load(that.final_order_url + 'edit');
        });
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__showExchangeErrorModal = function () {
        var that = this;

        $.uiModal({
            html: that.modals['exchange_error'],
            esc: false,
            close_on_avia_before_load: false,
            onBgClick: function (modal, event) {
                event.preventDefault();
                return false;
            },
            onClose: function () {
                $.sa.content_router.load((that.final_order_url ? that.final_order_url : that.order_url));
            }
        });
    };

    /**
     * @private
     */
    ExchangeCheckoutScreen.prototype.__showOrderContactDataModal = function () {
        var that = this;

        new OrderContactDataForm({
            modal: that.modals['order_contact_data'],
            onClose: function (is_valid, order_contact_data) {
                if (is_valid) {
                    that.order_contact_data = order_contact_data;
                    if (typeof that.onValid === 'function') {
                        that.onValid();
                    }
                }
            }
        });
    };

    /**
     * @param state
     * @private
     */
    ExchangeCheckoutScreen.prototype.__toggleConfirmTermsTooltip = function (state) {
        var that = this;

        if (state === 'show') {
            that.$confirm_terms_tooltip.css('opacity', '1');
            that.$confirm_terms_tooltip_checkbox.addClass(that.class.error);
        }

        if (state === 'hide') {
            that.$confirm_terms_tooltip.removeAttr('style');
            that.$confirm_terms_tooltip_checkbox.removeClass(that.class.error);
        }
    };

    ExchangeCheckoutScreen.prototype.__initConfirmTerms = function () {
        var that = this;

        that.$confirm_terms_checkbox.on('change', function () {
            var checked = $(this).prop('checked');
            if (checked) {
                that.__toggleConfirmTermsTooltip('hide');
            }

            that.$confirm_terms_checkbox.prop('checked', checked);
        });
    };

    ExchangeCheckoutScreen.prototype.__initFareremark = function () {
        var that = this;

        that.$fareremark_info.on('click', function () {
            if (that.screen_is_locked) {
                return;
            }

            var data;
            if (that.final_order_hash) {
                data = {
                    order_hash: that.final_order_hash
                };
            } else {
                data = {
                    order_hash: that.order_hash,
                    exchange_pricing_passenger_hashes: that.data.passenger_hashes,
                    exchange_pricing_segment_hash: that.data.segment_hash,
                    exchange_pricing_desired_date: that.data.desired_date,
                    exchange_pricing_desired_variant_hash: that.data.variant_hash
                };
                if (that.order_passenger_hash) {
                    data.order_passenger_hash = that.order_passenger_hash;
                }
            }

            $.uiFareremark(data);
        });
    };

    // EVENTS
    ExchangeCheckoutScreen.prototype.beforeUnload = function () {
        var that = this;

        that.screen_is_locked = true;
        that.$fareremark_info.addClass(that.class.disabled);
        that.$confirm_terms_checkbox.attr(that.attribute.disabled, true);
    };

    ExchangeCheckoutScreen.prototype.afterLoad = function () {
        var that = this;

        that.screen_is_locked = false;
        that.$fareremark_info.removeClass(that.class.disabled);
        that.$confirm_terms_checkbox.attr(that.attribute.disabled, false);
    };

    return ExchangeCheckoutScreen;
})($);
